<template>
  <v-card>
    <v-list-item>
    <v-progress-linear
      :value="arquivo.progress"
      color="green lighten-3"
      height="20"
      striped
    >
      <template v-slot:default="{ value }">
        {{arquivo.nome}} - upload
        <v-spacer></v-spacer>
        <strong>{{ Math.ceil(value) }}%</strong>
      </template>
    </v-progress-linear>
    </v-list-item>
  </v-card>
</template>
<style scoped>
.dense-list-item {
  padding: 0px;
  margin: 0px !important;
  min-height: 0px;
}
.inline-itens {
  flex-direction: row;
}
</style>
<script>

export default {
  props: {
    arquivo: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      cor_progresso: "primary",
    };
  },
};
</script>
